@use "../../styles/variables" as vars;

.section {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: clamp(40px, 5vw, 64px) clamp(26px, 3vw, 40px) clamp(48px, 6vw, 80px);
  background: vars.$color-page;
}

.layout {
  width: min(100%, 470px);
}

.heading {
  margin-bottom: 16px;
  text-align: center;

  h1 {
    margin: 0 0 14px;
    color: vars.$color-primary;
    font-family: vars.$font-heavy;
    font-size: clamp(32px, 2.8vw, 38px);
    line-height: 1.1;
  }

  p {
    max-width: 470px;
    margin: 0 auto;
    color: vars.$color-muted;
    font-size: 17px;
    line-height: 1.35;
  }
}

.card {
  display: grid;
  gap: 12px;
  padding: 22px;
  border-radius: vars.$radius-md;
  background: vars.$color-surface;
  box-shadow: 0 8px 32px rgb(0 0 0 / 10%);
}

.field {
  display: grid;
  gap: 3px;

  label {
    color: vars.$color-text;
    font-family: vars.$font-medium;
    font-size: 17px;
  }

  input {
    width: 100%;
    min-height: 36px;
    padding: 4px 0;
    border: 0;
    border-bottom: 1px solid vars.$color-muted;
    border-radius: 0;
    background: transparent;
    color: vars.$color-text;
    font-family: vars.$font-medium;
    font-size: 18px;

    &:focus {
      border-color: vars.$color-secondary;
      outline: none;
    }

    &[aria-invalid="true"] {
      border-color: vars.$color-primary;
    }
  }

  span {
    min-height: 15px;
    color: vars.$color-muted;
    font-size: 14px;
  }

  &:has(input[aria-invalid="true"]) > span {
    color: vars.$color-error;
  }
}

.submitButton {
  min-height: 38px;
  margin-top: 4px;
  border: 0;
  border-radius: vars.$radius-sm;
  background: vars.$color-secondary;
  color: vars.$color-text;
  cursor: pointer;
  font-family: vars.$font-heavy;
  font-size: 17px;
  box-shadow: vars.$shadow-button;
  transition: filter 0.2s ease;

  &:hover {
    filter: brightness(0.96);
  }

  &:disabled {
    cursor: wait;
    opacity: 0.72;
  }
}

.loginError {
  margin: 0;
  padding: 8px 10px;
  border: 1px solid vars.$color-error;
  border-radius: vars.$radius-sm;
  background: #fef3f2;
  color: vars.$color-error;
  font-size: 14px;
  line-height: 1.35;
}

@media (max-width: 600px) {
  .section {
    min-height: auto;
    padding: 28px 10px 36px;
  }

  .card {
    padding: 18px 14px;
  }
}

@media (min-width: 1081px) {
  .heading {
    h1 {
      font-size: clamp(26px, 2.22vw, 31px);
    }

    p {
      max-width: 470px;
      font-size: 14px;
    }
  }

  .field {
    label {
      font-size: 14px;
    }

    input {
      min-height: 36px;
      font-size: 14px;
    }

    span {
      font-size: 11px;
    }
  }

  .submitButton {
    min-height: 38px;
    font-size: 14px;
  }

  .loginError {
    font-size: 11px;
  }
}

@media (max-width: 600px) {
  .heading {
    h1 {
      font-size: 30px;
    }

    p {
      font-size: 14px;
    }
  }

  .field {
    label {
      font-size: 14px;
    }

    input {
      font-size: 16px;
    }

    span {
      font-size: 12px;
    }
  }

  .submitButton {
    font-size: 14px;
  }

  .loginError {
    font-size: 12px;
  }

}
